<template>
	<div id="Shippings" class="shippings">
		<vue-snotify></vue-snotify>
		<!-- ######################################################################################
			 ####                                  Nav de opciones                             ####
			 ######################################################################################-->
		<nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromShippings" @change="getAllShippings(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToShippings" @change="getAllShippings(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchShipping"
					v-model="searchShipping"
					v-on:keyup.enter="getAllShippings(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllShippings(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
				<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nuevo Envío" @click="showShippingNewModal">
					<i class="fas fa-box-open"></i>
				</button>
				<button class="btn btn-sm btn-outline-success my-2 my-sm-1 margin-right5" title="Despachar o Entregar" @click="showChangeStatusManifestoShippingModal">
					<i class="fas fa-dolly"></i>
				</button>
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" title="Asignar OF" @click="showAssignFreightOrderModal">
					<i class="fas fa-link"></i>
				</button>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsShipping" @change="changeQRowsShipping">
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
				<i class="far fa-list-alt margin-right5 pointer" ref="openManifestosModal" title="Manifiestos" @click="showManifestosModal"></i>
				<i class="fas fa-cog pointer" ref="openModalSetingModule"></i>
			</div>
		</nav>
	
		<!-- ######################################################################################
			 ####                                  Lista de Envios                             ####
			 ######################################################################################-->
		<table class="table table-sm table-hover table-12">
			<thead>
				<tr class="text-center">
					<th>ID</th>
					<th>Fecha</th>
					<th>Nº Doc</th>
					<th>Enviar a</th>
					<th>Domicilio</th>
					<th>Comuna</th>
					<th>Telefono</th>
					<th><label for="packages" ref="packages">Bultos</label></th>
					<th><label for="weight" ref="weight">Peso</label></th>
					<th>Forma</th>
					<th>Estado</th>
					<th>Manifiesto</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listShippingsFilter" :key="index">
					<td class="text-center" @dblclick="viewAllItem(item)">{{ item.id }}</td>
					<td class="text-center">{{ item.created_at }}</td>
					<td class="text-right">{{ item.document_number }}</td>
					<td>{{ item.sendto }}</td>
					<td>{{ item.address }}</td>
					<td>{{ item.comuna }}</td>
					<td>{{ item.phone }}</td>
					<td class="text-right width-50" @dblclick="changeValue('packages', item)">
						<input v-if="item.changeValuePackages" type="number" class="text-right width-50" id="packages"
							v-model="item.packages"
							@blur="item.changeValuePackages = !item.changeValuePackages; item.packages = item.packagesOld"
							@focus="$event.target.select()"
							v-on:keyup.enter="setValues(item.id, 'packages', item.packages, item.packagesOld)"/>
						<span v-else >{{ item.packages }}</span>
					</td>
					<td class="text-right width-50" @dblclick="changeValue('weight', item)">
						<input v-if="item.changeValueWeight" type="number" class="text-right width-50" id="weight"
							v-model="item.weight"
							@blur="item.changeValueWeight = !item.changeValueWeight; item.weight = item.weightOld"
							@focus="$event.target.select()"
							v-on:keyup.enter="setValues(item.id, 'weight', item.weight, item.weightOld)"/>
						<span v-else>{{ item.weight }}</span>
					</td>
					<td class="text-center">
						<b class="badge float-center" :class="(item.paid_shipping == 0) ? 'badge-warning' : ''">{{ (item.paid_shipping == 0) ? 'POR PAGAR' : 'CTA CTE' }}</b>
					</td>
					<td>{{ item.status }}</td>
					<td class="text-center">
						<span v-if="item.manifesto.length == 0">S/M</span>
						<b v-if="item.manifesto.length > 1" class="text-danger">!Error</b>
						<span v-if="item.manifesto.length == 1" :title="'Manifiesto Nº ' + item.manifesto[0].manifesto_id">
							<i class="pointer" :class="'badge badge-' + getColorTransport(item.manifesto[0].transport_id)" @click="showManifestoModal(item.manifesto[0].manifesto_id)"> {{item.manifesto[0].name}} </i>
						</span>
					</td>
					<td class="text-center">
						<i class="fas fa-boxes margin-right5 text-warning pointer" title="Admnistración de bultos" @click="editObjectShipping(item)"></i>
						<i class="fas fa-minus-circle text-danger pointer" @click="removeShippings(item)" v-if="item.freight_order == ''"></i>
					</td>
				</tr>
			</tbody>
		</table>
		<pagination :pagination="paginationListShippings" @getAllList="getAllShippings"></pagination>

		<!-- ######################################################################################
			 ####                        Modal de Envio (Nuevo - Editar)                       ####
			 ######################################################################################-->
		<div class="modal" id="shippingNewModal" tabindex="-1" role="dialog" aria-labelledby="shippingNewModalLabel" aria-hidden="true" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="shippingNewModalLabel">
							{{ (objectShipping.id == 0) ? 'Nuevo envío' : 'Envío Nº ' + objectShipping.id}}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group" v-if="objectShipping.id == 0">
							<label for="barcodeOrPackages" ref="barcodeOrPackages">
								Código de barra
								<span v-if="objectShipping.shipping_shippings_request.length > 0">
									<span v-if="objectShipping.packages == 0"> o número de bultos </span>
									<span v-if="(objectShipping.packages > 0 && objectShipping.weight == 0)"> o peso</span>
								</span>
							</label>
							<button class="fas fa-broom float-right" @click="clearObjectShipping" ref="clearObjectShipping" v-if="viewCardDataShipping"></button>
							<input class="form-control form-control-sm mr-sm-1" type="search" id="barcodeOrPackages" ref="searchBarcode"
									:placeholder="(objectShipping.shipping_shippings_request.length > 0) ? 'Código de barra o número de bultos' : 'Código de barra'" aria-label="Buscar"
									v-model="searchBarcode"
									v-on:keyup.enter="analyzeSearchBarcode"
									@focus="$event.target.select()">
						</div>
						<div class="card card-info card-outline" v-if="viewCardDataShipping">
							<div class="card-body box-profile">
								<h3 class="profile-username text-center">{{ objectShipping.sendto }}</h3>

								<p class="text-muted text-center">{{ objectShipping.commentary }}</p>

								<ul class="list-group list-group-unbordered mb-3">
									<li class="list-group-item">
										<p>
											<b>Dirección:</b> <span>{{ objectShipping.address }}</span>
										</p>
										<p>
											<b>Comuna:</b> <span>{{ objectShipping.comuna }}</span>
										</p>
										<p>
											<b>Telefono:</b> <span>{{ objectShipping.phone }}</span>
											<b class="badge float-right" :class="(objectShipping.paid_shipping == 0) ? 'badge-warning' : ''">{{ (objectShipping.paid_shipping == 0) ? 'POR PAGAR' : 'CTA CTE' }}</b>
										</p>
									</li>
								</ul>
								<div :class="'p-3 mb-2 text-center bg-' + getColorTransport(objectShipping.transport_id)">
									<h2>{{ objectShipping.transport }}</h2>
									<small v-if="objectShipping.freight_order.trim() != ''">OF <span class="pointer" @dblclick="getInfoShippingCourrier(objectShipping)">{{ objectShipping.freight_order }}</span></small>
								</div>
								<div class="row">
									<label class="col-sm p-3 mb-2 text-center bg-secondary pointer" for="barcodeOrPackages"
										:class="(objectShipping.packages == 0) ? 'border border-danger' : ''"
										@click="objectShipping.packages = 0">
										Bultos
										<h2>{{ objectShipping.packages }}</h2>
									</label>
									<label class="col-sm p-3 mb-2 text-center bg-dark pointer" for="barcodeOrPackages"
										:class="(objectShipping.packages > 0 && objectShipping.weight == 0) ? 'border border-danger' : ''"
										@click="objectShipping.weight = 0">
										Peso
										<h2>{{ objectShipping.weight }}</h2>
									</label>
								</div>
								<div class="form-group row">
									<label for="manifesto" class="col-sm-5 col-form-label">Asignar al Manifiesto: </label>
									<div class="col-sm-7">
										<select v-model="objectShipping.manifesto_id" id="manifesto" class="form-control form-control-sm" @change="setDefaultManifestoByTransport(objectShipping.manifesto_id, objectShipping.transport)">
											<option v-for="(item, index) in listManifestosFilter" :key="index" :value="item.id" v-if="objectShipping.transport_id == item.transport_id && item.status_id == 26">{{ item.name + ' (' + item.transport.name + ')'}}</option>
										</select>
									</div>
								</div>								
							</div>
						</div>
						<div v-if="objectShipping.shipping_shippings_request.length > 0 && objectShipping.id == 0">
							<table class="table table-sm table-hover table-12">
								<thead>
									<tr class="text-center">
										<th style="padding:0px">ID</th>
										<th style="padding:0px">Enviar a</th>
										<th style="padding:0px">Dirección</th>
									</tr>
								</thead>
								<tbody>
									<tr class="pointer" v-for="(item, index) in objectShipping.shipping_shippings_request" :key="index" for="barcodeOrPackages">
										<td @click="setSendtoObjectShipping(item)" :title="item.shipping_request.barcode">{{ item.shipping_request_id }}</td>
										<td @click="setSendtoObjectShipping(item)" v-if="item.shipping_request.shipping_request_recipient_data.length == 1">
											{{ item.shipping_request.shipping_request_recipient_data[0].sendto }}
										</td>
										<td @click="setSendtoObjectShipping(item)" v-if="item.shipping_request.shipping_request_recipient_data.length == 1">
											{{ item.shipping_request.shipping_request_recipient_data[0].address }},  
											{{ item.shipping_request.shipping_request_recipient_data[0].comuna }}
										</td>
										<td v-else colspan="2" title="Sin datos de envío">
											<i class="fas fa-exclamation-circle text-warning"></i> 
											{{ item.shipping_request.commentary }}
										</td>
										<td>
											<i class="fas fa-minus-circle text-danger pointer" @click="removeShippingShippingsRequest(item)"></i>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-if="objectShipping.shipping_packages.length > 0">
							<table class="table table-12 text-center">
								<thead>
									<tr>
										<th>Nº</th>
										<th>Fecha</th>
										<th>Etiqueta</th>
										<th><i class="fas fa-print" @click="toPrintLabelShippingAll(objectShipping.shipping_packages)"></i></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in objectShipping.shipping_packages" :key="index">
										<td>{{item.package_id}}</td>
										<td>{{item.created_at}}</td>
										<td>{{item.barcode}}</td>
										<th><i class="fas fa-print" @click="toPrintLabelShippingOne(item)"></i></th>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cerrar</button>
						<button type="button" class="btn btn-primary btn-sm" v-if="objectShipping.id == 0" :disabled="!saveCheck" @click="saveShippingLocal">Guardar</button>
					</div>
				</div>
			</div>
		</div>
		<button v-show="false" data-toggle="modal" data-target="#shippingNewModal" ref="btnShowShippingNewModal"></button>

		<!-- ######################################################################################
			 ####                      Modal para Asignar Ordenes de Flete                     ####
			 ######################################################################################-->
		<div class="modal" tabindex="-1" id="assignFreightOrderModal" role="dialog">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" style="border: 1px solid #f00: width: 100%">
							Asignar Orden de Flete
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="inputFreightOrder" ref="searchFreightOrder">
								Order de Flete
							</label>
							<input class="form-control form-control-sm mr-sm-1" type="search" id="inputFreightOrder" ref="inputFreightOrder"
								v-model="searchFreightOrder"
								v-on:keyup.enter="analizeSearchFreightOrder"
								@focus="$event.target.select()">
						</div>
						<div class="card card-success" v-show="listOfStarken.length > 0">
							<div class="card-header">
								<h3 class="card-title">Resultados de Staken</h3>
							</div>
							<!-- /.card-header -->
							<div class="card-body">
								<table class="table table-sm table-striped table-hover">
									<tbody>
									<tr v-for="(item, index) in listOfStarken" :key="index" @click="viewDetail(item)">
										<td>{{ item.of }}</td>
										<td>{{ item.created_at | dateZ }}</td>
										<td>{{ item.updated_at | dateZ }}</td>
										<td>{{ item.destination }}</td>
										<td>{{ item.receiver_name }}</td>
										<td>{{ item.status }}</td>
										<td>{{ item.status_op }}</td>
									</tr>
									</tbody>
								</table>
							</div>
							<!-- /.card-body -->
						</div>
						<hr>
						<div class="form-group row">
							<label for="searchShippingForAssingFreightOrder" class="col-sm-1 col-form-label">Enviado a:</label>
							<div class="col-sm-5">
								<input type="text" class="form-control-plaintext" id="searchShippingForAssingFreightOrder" ref="searchShippingForAssingFreightOrder"
								v-model="searchShippingForAssingFreightOrder"
								v-on:keyup.enter="analizeSearchShippingForAssingFreightOrder"
								@focus="$event.target.select()">
							</div>
						</div>
						<table class="table table-sm table-12">
							<thead>
								<tr class="text-center">
									<th>ID</th>
									<th>Nº Doc</th>
									<th>Enviar a</th>
									<th>Domicilio</th>
									<th>Comuna</th>
									<th>Bultos</th>
									<th>Peso</th>
									<th>Forma</th>
									<th>Manifiesto</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in listShippingsForAssingFreightOrder" :key="index" :title="item.created_at" @click="selectedListShippingsForAssingFreightOrder = item.id"
									:class="(selectedListShippingsForAssingFreightOrder == item.id) ? 'bg-info' : ''">
									<td class="text-center" @dblclick="viewAllItem(item)">{{ item.id }}</td>
									<td class="text-right">{{ item.document_number }}</td>
									<td>{{ item.sendto }}</td>
									<td>{{ item.address }}</td>
									<td>{{ item.comuna }}</td>
									<td class="text-right">{{ item.packages }}</td>
									<td class="text-right">{{ item.weight }}</td>
									<td class="text-center">
										<b class="badge float-center" :class="(item.paid_shipping == 0) ? 'badge-warning' : ''">{{ (item.paid_shipping == 0) ? 'POR PAGAR' : 'CTA CTE' }}</b>
									</td>
									<td class="text-center">
										<span v-if="item.manifesto.length == 0">S/M</span>
										<b v-if="item.manifesto.length > 1" class="text-danger">!Error</b>
										<span v-if="item.manifesto.length == 1" :title="'Manifiesto Nº ' + item.manifesto[0].manifesto_id">
											<i class="pointer" :class="'badge badge-' + getColorTransport(item.manifesto[0].transport_id)"> {{item.manifesto[0].name}} ({{ item.manifesto[0].id }}) </i>
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" :disabled="(selectedListShippingsForAssingFreightOrder == 0)" @click="assingFreightOrder">Asignar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
		<button v-show="false" data-toggle="modal" data-target="#assignFreightOrderModal" ref="btnShowAssignFreightOrderModal"></button>

		<starken-modal-component ref="starkenModalComponent" :item="itemSelectedStarken"></starken-modal-component>
   		<button class="btn-link" data-toggle="modal" data-target="#starkenModalComponent" ref="btnShowStarkenModalComponent" v-show="1 == 0"></button>

		<!-- ######################################################################################
			 ####             Modal para Cambiar Estados de Manifiesto o envio                 ####
			 ######################################################################################-->
		<div class="modal" tabindex="-1" id="changeStatusManifestoShippingModal" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" style="border: 1px solid #f00: width: 100%">
							Cambiar Estado (Manifiesto/Envio)
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<label for="barcodeMenifestoOrShipping" ref="barcodeMenifestoOrShipping">
							Código de barra
						</label>
						<input class="form-control form-control-sm mr-sm-1" type="search" id="barcodeMenifestoOrShipping" ref="refBarcodeMenifestoOrShipping"
								v-model="searchBarcodeMenifestoOrShipping"
								v-on:keyup.enter="analyzeSearchBarcodeMenifestoOrShipping"
								@focus="$event.target.select()">
						<div v-if="this.objectManifesto.id != '0'">
							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
		<button v-show="false" data-toggle="modal" data-target="#changeStatusManifestoShippingModal" ref="btnShowChangeStatusManifestoShippingModal"></button>

		<!-- Modal Manifiesto Component-->
		<button v-show="false" data-toggle="modal" data-target="#listManifestosModal" ref="btnShowListManifestosModal"></button>
		<div class="modal fade" id="listManifestosModal" role="dialog" aria-labelledby="listManifestosModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="listManifestosModalLabel">
							Manifiestos
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<list-manifestos-component
							:showManifestoLocal="false"
							ref="listManifestosComponent"
							@actionSaveManifesto="actionSaveManifestoLocal"
							@actionShowManifesto="actionShowManifestoLocal"
							@actionUpdateManifesto="actionUpdateManifestoLocal">
						</list-manifestos-component>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	
		<!-- Modal Manifiesto Component-->
		<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#manifestoComponentModalInShipping" ref="btnShowManifestoComponentModalInShipping" v-show="false">Abrir Manifiestos</button>
		<div class="modal fade" id="manifestoComponentModalInShipping" tabindex="-2" aria-labelledby="manifestoComponentModalInShippingLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-body">
						<manifesto-component
							ref="manifestoComponent"
							:id="manifestoIDSelected">
						</manifesto-component>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" aria-label="Close">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import shipping from '@/mixins/shippings'
import trackingsShipping from '@/mixins/shippings/trackingsShipping.js'
import manifestos from '@/mixins/manifestos'
import trackManifestoTrackShipping from '@/mixins/manifestos/trackManifestoTrackShipping.js'
import shippingRequest from '@/mixins/shippingsRequest'
import transport from '@/mixins/transports'
import webSocketServer from '@/mixins/webSocketServer.js'
import worker from '@/mixins/workers'
import label from "@/mixins/labels/"
import starken from "@/mixins/starken/"

import Pagination from '@/components/Pagination.vue'
import StarkenModalComponent from '@/components/StarkenModalComponent.vue'
import ListManifestosComponent from '@/components/ListManifestosComponent.vue'
import ManifestoComponent from '@/components/ManifestoComponent.vue'

export default {
	name: 'Shippings',
	mixins: [axiosAction, errors, mixin, shipping, manifestos, trackManifestoTrackShipping, shippingRequest, trackingsShipping, transport, worker, webSocketServer, label, starken],
	data() {
		return {
			searchBarcode: '',
			searchBarcodeMenifestoOrShipping: '',
			listAcceptedIdStatus: [ 13 ],
			statusIdAttened: 11,
			searchFreightOrder: ''
		}
	},
	computed: {
		listManifestosFilter() {
			let list = this.listManifestos
			return list
		},
		listShippingsFilter() {
			let list = this.listShippings
			return list
		},
		saveCheck() {
			if(this.objectShipping.sendto.trim() == '')
				return false
			if(this.objectShipping.address.trim() == '')
				return false
			if(this.objectShipping.comuna.trim() == '')
				return false
			if(parseInt(this.objectShipping.packages) == 0)
				return false
			if(parseInt(this.objectShipping.weight) == 0)
				return false
			if(this.objectShipping.manifesto_id == 0)
				return false
			return true
		},
		viewCardDataShipping() {
			if(this.objectShipping.sendto.trim() == '')
				return false
			return true
		}
	},
	methods: {
		actionSaveManifestoLocal(manifesto) {
			if(parseInt(manifesto.status_id) == 26) {
				this.listManifestos.unshift(manifesto)
			}
		},
		actionShowManifestoLocal(id) {
			this.showManifestoModal(id)
		},
		actionUpdateManifestoLocal(manifestoTrackingManifesto, manifesto) {
			console.log(manifestoTrackingManifesto, manifesto)
			let index = this.listTrackManifestoTrackShippings.map(e => parseInt(e.tracking_manifesto_id)).indexOf(parseInt(manifestoTrackingManifesto.trackings_manifesto_id))
			if(index > -1) {
				let index_ = this.listTrackingsShipping.map(e => parseInt(e.id)).indexOf(parseInt(this.listTrackManifestoTrackShippings[index].tracking_shipping_id))
				if(index_ > -1) {
					if(this.listTrackingsShipping[index_].status != null) {
						this.listShippings.forEach(shipping => {
							if(shipping.manifesto[0].manifesto_id == manifestoTrackingManifesto.manifesto_id) {
								shipping.status = this.listTrackingsShipping[index_].status.name
							}
						})
					}
				}
			}
			if(manifesto != null) {
				index = this.listManifestos.map(e => parseInt(e.id)).indexOf(parseInt(manifesto.id))
				if(index > -1 && parseInt(manifesto.status_id) != 26) {
					this.listManifestos.splice(index, 1)
				} if (index == -1 && parseInt(manifesto.status_id) == 26) {
					this.actionSaveManifestoLocal(manifesto)
				}
			}
		},
		initModuleLocal() {
			this.setTitleModule('Modulo de Envío')
			this.setSubTitleModule('')
			this.dateFromShippings = this.currentDate()
			this.dateToShippings = this.currentDate()
			this.dateFromManifesto = this.currentDate(-30)
			this.dateToManifesto = this.currentDate()
			this.qRowsManifesto = (localStorage.getItem('qRowsManifesto') === null) ? this.qRowsManifesto : localStorage.getItem('qRowsManifesto')
			this.qRowsShipping = (localStorage.getItem('qRowsShipping') === null) ? this.qRowsShipping : localStorage.getItem('qRowsShipping')
			this.getAllManifestosByStatusId(26)
			this.getAllTransports()
			this.getAllTrackingsShipping()
			this.getAllTrackManifestoTrackShipping()
			this.setListeningShipping()
			this.getAllShippings()
			this.showLabel(2)
		},
		addRowListManifestos() {
			if(this.listManifestos.length == 0 || this.listManifestos[0].id != 0) {
				this.clearObjectManifesto()
				this.listManifestos.unshift(this.objectManifesto)
			}
		},
		addShippingTrackingsShippingResultLocal(response) {
			if(response.data.success == true) {
				this.searchBarcodeMenifestoOrShipping = ''
				this.$refs.barcodeMenifestoOrShipping.click()
			}
		},
		analyzeSearchBarcode() {
			if(this.searchBarcode.length == 22) {
				this.getShippingsRequestByBarcode(this.searchBarcode.substring(0,18))
			} else if(!isNaN(this.searchBarcode)) {
				if(this.objectShipping.shipping_shippings_request.length > 0) {
					if(this.objectShipping.packages == 0) {
						this.objectShipping.packages = this.searchBarcode
					} else if (this.objectShipping.weight == 0) {
						this.objectShipping.weight = this.searchBarcode
					}
				} else {
					this.$snotify.error('Información incorrecta', 'Error')
				}
			} else {
				this.$snotify.error('Información incorrecta', 'Error')
			}
			this.searchBarcode = ''
		},
		analizeSearchFreightOrder() {
			this.showShipping(this.searchFreightOrder)
			this.searchShippingForAssingFreightOrder = ''
			this.listOfStarken = []
			this.listShippingsForAssingFreightOrder = []
		},
		analizeSearchShippingForAssingFreightOrder() {
			this.searchForAssignFreightOrder(this.searchShippingForAssingFreightOrder,)			
		},
		analyzeAcceptedIdStatus(idStatus) {
			return this.listAcceptedIdStatus.map((el) => parseInt(el)).indexOf(parseInt(idStatus))
		},
		analyzeSearchBarcodeMenifestoOrShipping() {
			this.searchBarcodeMenifestoOrShipping = this.searchBarcodeMenifestoOrShipping.trim()
			if(this.searchBarcodeMenifestoOrShipping.length == 11) {
				this.clearObjectManifesto()
				this.showManifesto(this.searchBarcodeMenifestoOrShipping, 'changeStatus')
			} else if(this.searchBarcodeMenifestoOrShipping.length == 22){
				this.clearObjectShipping()
				this.showShipping(this.searchBarcodeMenifestoOrShipping, 'changeStatus')
			} else {
				alert(this.searchBarcodeMenifestoOrShipping.length)
			}
		},
		assingFreightOrder() {
			this.updateShippingByField(this.selectedListShippingsForAssingFreightOrder, 'freight_order', this.searchFreightOrder)
		},
		clearDataModal(){
			this.selectedListShippingsForAssingFreightOrder = 0
			this.searchFreightOrder = ''
			this.searchShippingForAssingFreightOrder = ''
			this.listOfStarken = []
			this.listShippingsForAssingFreightOrder = []
		},
		changeStatusManifesto(item) {
			let trackingsManifestoId = (!item.opened) ? 2 : 4
			this.addManifestoTrackingsManifesto(item.id, trackingsManifestoId)
		},
		changeValue(concept, item) {
			if(concept == 'packages') {
				item.packagesOld =item.packages
				item.changeValuePackages = true
				setTimeout(()=>{this.$refs.packages.click()}, 10)
			} else if(concept == 'weight') {
				item.weightOld =item.weight
				item.changeValueWeight = true
				setTimeout(()=>{this.$refs.weight.click()}, 10)
			}
		},
		deleteManifestoResultLocal(item) {
			this.$snotify.info('Se ha borrado con el manifiesto ' + item.id + '- ' + item.name, 'Realizado')
		},
		deleteManifestoShippingResultLocal(response) {
			this.deleteListShippingManifestoShipping(response.data.shipping_id, response.data.manifesto_id)
			this.socketEmit(['DELETE_SHIPPING_MANIFESTO_SHIPPING'], response.data)
		},
		getDefaultManifestoByTransport(transport) {
			let manifestoId = localStorage.getItem('MA' + transport.replaceAll(' ', '').toUpperCase())
			let index = this.listManifestos.map((el) => parseInt(el.id)).indexOf(parseInt(manifestoId))
			if(index > -1) {
				if(this.listManifestos[index].status_id == 26) {
					return manifestoId
				}
			}
			localStorage.removeItem('MA' + transport.replaceAll(' ', '').toUpperCase())
			return 0
		},
		getShippingsRequestByBarcodeResultLocal(response) {
			if(response.data.success && this.analyzeAcceptedIdStatus(response.data.data.status_id) > -1) {
				if(this.objectShipping.id == 0) {
					let item = response.data.data
					let index = this.objectShipping.shipping_shippings_request.map((el) => parseInt(el.shipping_request_id)).indexOf(parseInt(item.id))
					if(index == -1) {
						let object = {'shipping_id':this.objectShipping.id, 'shipping_request_id': item.id, 'created_at': '', 'updated_at': '', 'shipping_request': item }
						this.addListShippingShippingsRequest(object)
						if(this.objectShipping.sendto.trim() == '') {
							this.setSendtoObjectShipping(object)
						}
					} else {
						this.$snotify.info('Esta solicitud de envío ya está en la lista', 'Ya existe')
					}
				}
			} else {
				if(!response.data.success) {
					this.$snotify.warning('Solicitud de envío no encontrada ('+ this.searchBarcode +')', 'Sin Encontrar')
				} else {
					this.$snotify.warning('El estado de este pedido no está para enviar "' + response.data.data.status + '"', 'Estado erroneo')
				}
			}
		},
		getAllManifestosResultLocal(response) {},
		getAllTrackManifestoTrackShippingResultLocal(response) {},
		getAllTrackingsShippingResultLocal(response) {},
		getAllTransportsResultLocal(response) {},
		markAsDispatched(manifesto) {
			if(confirm('El estado del manifiesto ' + manifesto.name + '(' + manifesto.id + ') quedará como despachado, no se podra volver a atras\n¿Deseas continuar?')) {
				this.setTrackingManifesto(manifesto, 6)
			}
		},
		setTrackingManifesto(manifesto, trackingsManifestoId) {
			let index = this.trackingsManifestoShipping.map((el) => parseInt(el.trackings_manifesto_id)).indexOf(parseInt(trackingsManifestoId))
			let requests = 0
			if(index > -1) {
				Object.entries(manifesto.shippings).forEach(([i, shippings]) => {
					requests+= this.setTrackingShipping(shippings, this.trackingsManifestoShipping[index].trackings_shipping_id)
				})
			}
			requests++
			this.addManifestoTrackingsManifesto(manifesto.id, trackingsManifestoId)
			console.log('Las peticiones PHP por este manifiesto son: ' + requests)
		},
		setTrackingShipping(shippings, trackingShippingId, observation = '') {
			let index = this.trackingsShippingShippingRequest.map((el) => parseInt(el.trackings_shipping_id)).indexOf(parseInt(trackingShippingId))
			let requests = 0
			if(index > -1) {
				Object.entries(shippings.shipping_shippings_request).forEach(([x, shipping_shippings_request]) => {
					requests++
					this.addShippingRequestTrackingsShippingRequest(shipping_shippings_request.shipping_request_id, this.trackingsShippingShippingRequest[index].trackings_shipping_request_id, observation)
				})
			}
			requests++
			this.addShippingTrackingsShipping(shippings.id, trackingShippingId, observation)
			console.log('Las peiciones PHP por este envio son: ' + requests)
			return requests
		},
		removeShippings(item) {
			if(confirm('Esta a punto de borrar el envio de "' + item.sendto + ' (' + item.id + ')"\n¿Quiere continuar?')) {
				this.deleteShipping(item.id)
			}
		},
		removeManifestoShipping(object, item) {
			if(confirm('Está a punto de borrar el envio Nº ' + item.id + ' de '+ item.sendto + ' del manifiesto ' + object.name + '(' + object.id +')\n¿Quiere continuar?')) {
				this.deleteManifestoShipping(object.id, item.id)
			}
		},
		removeShippingShippingsRequest(item) {
			let itemRemove = this.deleteListShippingShippingsRequest(item.shipping_request_id)
			if(this.objectShipping.shipping_shippings_request.length == 0) {
				setTimeout(() => { this.$refs.clearObjectShipping.click() }, 10)
			} else {
				let index = this.objectShipping.shipping_shippings_request.map((el) => parseInt(el.shipping_request_id)).indexOf(parseInt(this.objectShipping.shipping_request_id))
				if(index == -1)
					this.setSendtoObjectShipping(this.objectShipping.shipping_shippings_request[0])
				else
					this.setSendtoObjectShipping(this.objectShipping.shipping_shippings_request[index])
			}
			this.$refs.barcodeOrPackages.click()
		},
		removeManifesto(item) {
			if(confirm('Esta a punto de borrar el manifiesto "' + item.id + '- ' + item.name + '"\n¿Quiere continuar? ')) {
				this.deleteManifesto(item.id)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'addManifestoTrackingsManifestoResult': this.addManifestoTrackingsManifestoResult(response); break;
				case 'addShippingTrackingsShippingResult': this.addShippingTrackingsShippingResult(response); break;
				case 'deleteManifestoResult': this.deleteManifestoResult(response); break;
				case 'deleteManifestoShippingResult': this.deleteManifestoShippingResult(response); break;
				case 'deleteShippingResult': this.deleteShippingResult(response); break;
				case 'resultShowLabelGET': this.resultAxiosLocalLabel(responseLocal, response); break;
				case 'getShippingsRequestByBarcodeResult': this.getShippingsRequestByBarcodeResult(response); break;
				case 'getAllManifestosResult': this.getAllManifestosResult(response); break;
				case 'getAllShippingsResult': this.getAllShippingsResult(response); break;
				case 'getAllTrackManifestoTrackShippingResult': this.getAllTrackManifestoTrackShippingResult(response); break;
				case 'getAllTrackingsShippingResult': this.getAllTrackingsShippingResult(response); break;
				case 'resultAddShippingRequestTrackingsShippingRequestPOST': this.resultAxiosLocalShippingRequest(responseLocal, response); break;
				case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
				case 'saveManifestoPOSTResult': this.saveManifestoPOSTResult(responseLocal, response); break;
				case 'saveShippingPOSTResult': this.saveShippingPOSTResult(responseLocal, response); break;
				case 'searchForAssignFreightOrderResult': this.searchForAssignFreightOrderResult(response); break;
				case 'showShippingResult': this.showShippingResult(response); break;
				case 'showManifestoResult': this.showManifestoResult(response); break;
				case 'updateShippingByFieldResult': this.updateShippingByFieldResult(response); break;
				
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		saveManifestoLocal() {
			if(this.objectManifesto.transport_id > 0 && this.objectManifesto.name.trim() != "") {
				this.saveManifesto()
			} else {
				this.$snotify.warning('Tienes que llenar todos los datos', 'Falta Datos')
			}
		},
		saveShippingLocal() {
			if(this.saveCheck) {
				this.saveShipping()
			}
		},
		saveShippingPOSTResultLocal(newShipping) {
			this.objectShipping.shipping_shippings_request.forEach(element => {
				this.addShippingRequestTrackingsShippingRequest(element.shipping_request_id, this.statusIdAttened)
			});
			this.toPrintLabelShippingAll(newShipping.shipping_packages, false)
			this.clearObjectShipping()
			this.$refs.searchBarcode.focus()
		},
		searchForAssignFreightOrderResultLocal(response) {
			this.listShippingsForAssingFreightOrder = response.data.data
		},
		searchOFStarkenResultLocal(response, action) {
			if(this.listOfStarken.length == 1) {
				if(action == 1) {
					this.searchShippingForAssingFreightOrder = this.listOfStarken[0].receiver_name
					this.$refs.searchShippingForAssingFreightOrder.focus()
					this.searchForAssignFreightOrder(this.listOfStarken[0].receiver_name, this.listOfStarken[0].destination)
				} else if(action == 2) {
					this.itemSelectedStarken = this.listOfStarken[0]
					setTimeout(()=>{this.$refs.btnShowStarkenModalComponent.click()}, 10)
				}
			}
		},
		searchOFStarkenErrorLocal(error) {
			this.$snotify.error('No se puede obtener datos del courrier', 'No Encontrado')
			this.$refs.searchShippingForAssingFreightOrder.focus()
		},
		setDefaultManifestoByTransport(manifestoId, transport) {
			localStorage.setItem('MA' + transport.replaceAll(' ', '').toUpperCase(), manifestoId)
		},
		setListeningShipping() {
			this.sockets.subscribe('DELETE_SHIPPING', (data) => { this.deleteItemListShippings(data.body) })
			this.sockets.subscribe('DELETE_SHIPPING_MANIFESTO_SHIPPING', (data) => { this.deleteListShippingManifestoShipping(data.body.shipping_id, data.body.manifesto_id) })
			this.sockets.subscribe('UPDATE_SHIPPING', (data) => { this.setListShippingsByItem(data.body) })
			this.sockets.subscribe('NEW_SHIPPING_TRACKINGS_SHIPPING', (data) => { this.updateShippingStatus(data.body) })
		},
		setSendtoObjectShipping(object) {
			if(object.shipping_request.shipping_request_recipient_data.length == 1) {
				let item = object.shipping_request.shipping_request_recipient_data[0]
				this.objectShipping.barcode = object.shipping_request.barcode
				this.objectShipping.commentary = object.shipping_request.commentary
				this.objectShipping.sendto = item.sendto
				this.objectShipping.address = item.address
				this.objectShipping.comuna = item.comuna
				this.objectShipping.phone = item.phone
				this.objectShipping.paid_shipping = item.paid_shipping
				this.objectShipping.transport_id = item.transport_id
				this.objectShipping.transport = item.transport
	            this.objectShipping.shipping_request_id = item.shipping_request_id
				this.objectShipping.manifesto_id = this.getDefaultManifestoByTransport(item.transport)
			}
		},
		setValues(id, field, value, valueOld) {
			if(value != valueOld) {
				this.updateShippingByField(id, field, value)
			}
			this.$refs.searchShipping.focus()
		},
		showShippingResultLocal(response) {
			if(!response.data.success) {
				this.searchOFStarken(this.searchFreightOrder)
			} else {
				if(response.data.data.action == 'view') {
					this.$refs.inputFreightOrder.select()
					this.$snotify.warning('La orden de flete ' + this.searchFreightOrder + ' ya está asignada al envío Nº ' + response.data.data.id, 'Ya Asignada')
				} else if(response.data.data.action == 'changeStatus') {
					let trackingShippingId = (response.data.data.transport_id == 1) ? 4 : 3
					let index = this.trackingsShippingShippingRequest.map((el) => parseInt(el.trackings_shipping_id)).indexOf(parseInt(trackingShippingId))
					let statusName = this.trackingsShippingShippingRequest[index].trackings_shipping_status_name
					if(response.data.data.status_id == 22) {
						let data = ''
						let index = response.data.data.shipping_trackings_shipping.map((el) => parseInt(el.trackings_shipping_id)).indexOf(4)
						if(index > -1) {
							data = ' a ' + response.data.data.shipping_trackings_shipping[index].observation
						}
						alert('El envío Nº ' + response.data.data.id + ' ya fue ENTREGADO' + data)
						this.searchBarcodeMenifestoOrShipping = ''
					} else {
						if(confirm('El Envío Nº ' + response.data.data.id + ' para ' + response.data.data.sendto + ' se marcara como ' + statusName + '\n¿Continuar?')) {
							let observation = ''
							if(response.data.data.transport_id == 1) {
								observation = prompt('Escriba quien lo retiró', response.data.data.sendto)
							}
							this.setTrackingShipping(response.data.data, trackingShippingId, observation)
							this.searchFreightOrder = ''
						}
					}
				}
			}
		},
		showLabelResultLocal(response) {},
		showManifestoModal(id) {
			this.manifestoIDSelected = id
			setTimeout(()=>{ 
				this.$refs.manifestoComponent.$refs.btnShowManifesto.click()
				this.$refs.btnShowManifestoComponentModalInShipping.click()
			}, 100)
		},
		showManifestoResultLocal(response) {
			this.setObjectManifesto(response.data.data)
			if(response.data.data.action == 'view') {
				this.$refs.btnShowManifestoModal.click()
			} else if(response.data.data.action == 'changeStatus') {
				if(response.data.data.status_id == 27) {
					setTimeout(()=>{ this.markAsDispatched(response.data.data) }, 10)
				} else {
					let status = response.data.data.status
					let id = response.data.data.id
					this.clearObjectManifesto()
					this.$snotify.error('El Manifiesto Nº' + id + ' tiene que estar CERRADO, y el estatus actual es "' + status + '"', 'NO MODIFICADO')
					setTimeout(()=>{ this.$refs.barcodeMenifestoOrShipping.click() }, 100)
				}
			}
		},
		showManifestosModal() {
			this.$refs.listManifestosComponent.$refs.btnGetManifestos.click()
			this.$refs.btnShowListManifestosModal.click()
		},
		showShippingNewModal() {
			this.clearObjectShipping()
			this.$refs.btnShowShippingNewModal.click()
			setTimeout(() => {
				this.$refs.barcodeOrPackages.click()
			}, 100)
		},
		showAssignFreightOrderModal() {
			this.clearDataModal()
			this.$refs.btnShowAssignFreightOrderModal.click()
			this.$refs.searchFreightOrder.click()
		},
		showChangeStatusManifestoShippingModal() {
			this.clearObjectManifesto()
			this.searchBarcodeMenifestoOrShipping = ''
			this.$refs.btnShowChangeStatusManifestoShippingModal.click()
			this.$refs.barcodeMenifestoOrShipping.click()
		},
        updateShippingByFieldResultLocal(response) {
			if(response.data.message == 'freight_order') {
				this.$snotify.success('La OF Nº ' + response.data.data.freight_order + ' ha sido asignada al envio Nº ' + response.data.data.id, 'Asignado!!!')
				this.clearDataModal()
				this.$refs.searchFreightOrder.click()
			}
        },
		updateStatusManifestoLocal(manifestoTrackingsManifesto) {
			if(this.objectShipping.manifesto_id == manifestoTrackingsManifesto.manifesto_id && manifestoTrackingsManifesto.statu.id != 25) {
				this.objectShipping.manifesto_id = 0
				console.log(manifestoTrackingsManifesto.manifesto_id, localStorage.getItem('MA' + this.objectShipping.transport.replaceAll(' ', '').toUpperCase()))
				if(manifestoTrackingsManifesto.manifesto_id == localStorage.getItem('MA' + this.objectShipping.transport.replaceAll(' ', '').toUpperCase())) {
					localStorage.removeItem('MA' + this.objectShipping.transport.replaceAll(' ', '').toUpperCase())
				}
			}
		},
		viewDetail(item) {
			this.itemSelectedStarken = item
			this.$refs.btnShowStarkenModalComponent.click()
		}
	},
	components: {
		'pagination': Pagination,
		'starken-modal-component': StarkenModalComponent,
		'list-manifestos-component': ListManifestosComponent,
		'manifesto-component': ManifestoComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>